<template>
  <div class="header-main mb-4 pb-3">
    <!-- <v-toolbar light dense fixed class="header-toolbar"> -->
    <v-toolbar light dense fixed color="white">

      <router-link class="rtlnk" :to="{ name: 'TkProfileView', params: {id: id} }">
        <v-icon color="grey darken-2" class="pr-3 pb-1">arrow_back</v-icon>
      </router-link>
      <vue-letter-avatar :name="profileinfo.tkname" size="35" :rounded="true" />
      <v-toolbar-title class="pa-2 ma-0 tktitle" v-text="profileinfo.tkname"></v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn active-class icon to="/tkbios">
        <v-tooltip color="blue" nudge-left="40px" bottom>
          <!-- <v-icon slot="activator" color="black" dark>fa fa-paw</v-icon> -->
          <v-icon slot="activator" color="black" dark>fas fa-cat</v-icon>
          <span>Back to All TK Cat Bios</span>
        </v-tooltip>
      </v-btn>

      <v-btn active-class icon to="/">
        <v-tooltip color="blue" nudge-left="30px" bottom>
          <v-icon slot="activator" color="black" dark>fa fa-home</v-icon>
          <span>Back to Home</span>
        </v-tooltip>
      </v-btn>

      <v-btn active-class icon flat round href="https://www.facebook.com/timmyskittys1" target="_blank">
        <v-tooltip color="blue" nudge-left="40px" bottom>
          <v-icon slot="activator" color="black" dark>fab fa-facebook-square</v-icon>
          <span>Visit Us on Facebook</span>
        </v-tooltip>
      </v-btn>

    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    id: {
      type: String,
      required: false
    }
  },
  data: () => ({

  }),
  computed: {
    ...mapGetters([
      // 'getByName'
      'getById'
    ]),
    profileinfo () {
      return this.getById(this.id)
    }
  },
}
</script>

<style scoped>
.header-main  {
  /*  */
}
.header-toolbar  {
  background-color: #f8f8ff;
}
.tktitle {
  text-transform: capitalize;
  font-size: 2rem;
  text-shadow: -2px 2px 3px rgba(0, 0, 0, .3);
}
.rtlnk {
  list-style-type: none;
  text-decoration: none;
}
.header {
  text-transform: capitalize;
  font-size: 2rem;
}
.tk-bio-name {
  text-transform: capitalize;
  font-size: 2rem;
  text-shadow: -2px 2px 3px rgba(0, 0, 0, .3);
}
.tk-bio-name::first-letter {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 3.2rem;
  line-height: 0;
  font-weight: bolder;
  color: black;
  margin-right: 3px;
}


/************************************** iPhones *************************************/
@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  .tktitle {
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .tktitle {
    font-size: 1.6rem;
  }
}
/* iPhone X ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .tktitle {
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .tktitle {
    font-size: 1.6rem;
  }
}
/* iPhone 6/7/8/X plus ----------- */
@media only screen and (min-device-width: 414px) and (max-device-height: 896px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .tktitle {
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 414px) and (max-device-height: 896px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .tktitle {
    font-size: 1.6rem;
  }
}
/* Samsung Galaxy S5 ----------- */
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .tktitle {
    font-size: 1.6rem;
  }
}
/* Samsung Galaxy III */
@media screen and (device-width: 360px) and (device-height: 640px) and (orientation: portrait) {
  .tktitle {
    font-size: 1.4rem;
  }
}
/* Nexus */
@media screen and (device-width: 600px) and (device-height: 960px) and (orientation: portrait) {
  .tktitle {
    font-size: 1.6rem;
  }
}
/* Amazon Fire HD 8.9 */
@media only screen  and (min-device-width: 1200px) and (max-device-width: 1920px) and (orientation: portrait) {
  .tktitle {
    font-size: 1.6rem;
  }
}
/* Amazon Fire HD 8.9 */
@media only screen and (min-device-width: 800px) and (max-device-width: 1.60px) and (orientation: portrait) {
  .tktitle {
    font-size: 1.6rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/TkHeaderView.vue